export default __webpack_public_path__ + "static/media/07 Track 7.1ccb3ea8.mp3";